module.exports = __webpack_public_path__ + "static/media/business_report-ioc.090821e2.png";